import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { AnalysisServiceApi } from "../../http/api/analysis.api";
import { AnalysisGetReq, AnalysisGetRes } from "../../types/api/analysis.api.types";
import { AnalysisApi } from "../../types/entities/analysis.types";
import { handleTokenRefreshedRequest } from "../../utils/handleThunkAuth";
import { FilialApi, getFiliaslRes } from "../../types/api/utils.api.types";
import { UtilsApi } from "../../http/api/utils.api";


type ProductSliceState = {
    loadings: {
        products: boolean,
        pagination: boolean,
    }
    items: AnalysisApi[];
    can_next: boolean
    part: number,
    filials: FilialApi[],
    templates: any[],
    all: AnalysisApi[],
}

const initialState: ProductSliceState = {
    loadings: {
        products: true,
        pagination: false,
    },
    items: [],
    can_next: false,
    part: 0,
    filials: [],
    templates: [],
    all: [],
}
export const getProducts = createAsyncThunk(
    'all/products/get',
    async (req: AnalysisGetReq, { dispatch }) => {
        const res: AxiosResponse<AnalysisGetRes> = await handleTokenRefreshedRequest(null, AnalysisServiceApi.GetByTitle, req)
        return res.data
        // return new Promise<AnalysisGetRes>((res, rej) => {
        //     setTimeout(() => {
        //         res({
        //             can_next: true,
        //             status: true,
        //             analiz: Array(10).fill("").map((item, index) => {
        //                 return {
        //                     id: index,
        //                     cat: 1,
        //                     code: "",
        //                     cost: 300,
        //                     info: "dfdsf",
        //                     maxdur: 1,
        //                     mindur: 10,
        //                     name: "Какой-то анализ" + " " + index,
        //                     prepare: [],
        //                     tags: [],
        //                     templates: []
        //                 }
        //             })
        //         })
        //     }, 1000)

        // })
    })

export const getUsiProducts = createAsyncThunk(
    'usi/products/get',
    async (req: Omit<AnalysisGetReq, "id">, { dispatch }) => {
        const res: AxiosResponse<AnalysisGetRes> = await handleTokenRefreshedRequest(null, AnalysisServiceApi.GetUsiList, req)
        return res.data
    })

export const getFilials = createAsyncThunk(
    'filials/get',
    async (req: {"type": number}, { dispatch }) => {
        const res: AxiosResponse<getFiliaslRes> = await handleTokenRefreshedRequest(null, UtilsApi.GetFilials, req)
        return res.data
    })

     export const getAllProducts = createAsyncThunk(
    'products/get_all',
    async (_, { dispatch }) => {
        const res: AxiosResponse<AnalysisGetRes> = await handleTokenRefreshedRequest(null, UtilsApi.GetAllProducts)
        return res.data
    })

export const ProductsSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        resetProducts: state => {
            state.items = initialState.items
            state.can_next = false
            state.part = 0
        },
        incrementProductsPart: state => {
            state.part += 1
        },
        resetPart: state => {
            state.part = 1
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getProducts.pending, state => {
            if (state.part > 1) {
                state.loadings.pagination = true
                return
            }
            state.loadings.products = true
        })
        builder.addCase(getProducts.fulfilled, (state, action) => {
            state.items = [...state.items, ...action.payload.analiz]
            state.can_next = action.payload.can_next
            state.loadings.pagination = false
            state.loadings.products = false
            if (state.part === 0) {
                state.part = 1
            }
        })
        builder.addCase(getProducts.rejected, (state, action) => {
            state.loadings.pagination = false
            state.loadings.products = false
        })

        builder.addCase(getUsiProducts.pending, state => {
            if (state.part > 1) {
                state.loadings.pagination = true
                return
            }
            state.loadings.products = true
        })
        builder.addCase(getUsiProducts.fulfilled, (state, action) => {
            state.items = [...state.items, ...action.payload.analiz]
            state.can_next = action.payload.can_next
            state.loadings.pagination = false
            state.loadings.products = false
            if (state.part === 0) {
                state.part = 1
            }
        })
        builder.addCase(getUsiProducts.rejected, state => {
            state.loadings.pagination = false
            state.loadings.products = false
        })

        builder.addCase(getFilials.fulfilled, (state, action) => {
            state.filials = Array.isArray(action.payload) ? action.payload : []
        })

        builder.addCase(getAllProducts.fulfilled, (state, action) => {
          state.all = action.payload.analiz
          state.templates = action.payload.templates
          console.log(state.templates.find((el: any) => el.id === 568))
        })
    },
})
export const {
    resetProducts,
    resetPart,
    incrementProductsPart
} = ProductsSlice.actions
export const productsReducer = ProductsSlice.reducer